<ridango-dropdown-filter-wcag class="card-dropdown" *ngIf="showCardTypeSelect" [placeholder]="'CARD_TYPE'"
    [items]="allowedCardTypes" [filter]="selectedCardType?.name" [selectedItem]="selectedCardType" [required]="required"
    (onItemSelected)="cardTypeSelected($event)">
</ridango-dropdown-filter-wcag>

<ridango-form-field class="form-margin-10">
    <input class="text-input" ridangoInput [formControl]="cardNumberForm.controls.card_number" name="travelcard.number"
        (change)="change()" #cardInput [required]="required">
    <ridango-label>{{'PH_INSERT_TRAVELCARD_NUMBER' | translate}}</ridango-label>

    <ridango-error *ngIf="cardNumberForm.controls.card_number.hasError('required')">
        {{'FIELD_VALIDATION_REQUIRED' | translate}}
    </ridango-error>

    <ridango-error *ngIf="cardNumberForm.controls.card_number.hasError('pattern')">
        {{'FIELD_VALIDATION_CARD_NUMBER_INVALID_FORMAT' | translate}}
    </ridango-error>

    <ridango-error *ngIf="cardNumberForm.controls.card_number.hasError('minlength')">
        {{'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
    </ridango-error>

    <ridango-error *ngIf="cardNumberForm.controls.card_number.hasError('maxlength')">
        {{'LOCAL_INPUT_VALIDATION_MAX_LENGTH' | translate }}
    </ridango-error>
</ridango-form-field>
